import { render, staticRenderFns } from "./relic-detail-census-point-cloud.vue?vue&type=template&id=49bb096c&scoped=true"
import script from "./relic-detail-census-point-cloud.vue?vue&type=script&lang=js"
export * from "./relic-detail-census-point-cloud.vue?vue&type=script&lang=js"
import style0 from "./relic-detail-census-point-cloud.vue?vue&type=style&index=0&id=49bb096c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bb096c",
  null
  
)

export default component.exports